import { Avatar, Button, Checkbox, Divider, Form, Input, Row, Space } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import AuthService from "../../services/auth.service";
import { Navigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { UserType, UserTypeAtom } from '../../atom/user.atom';
import jwtDecode from 'jwt-decode';
import { JwtToken, CbSignUpType } from '../../types/user.type';
import { CustomAxios } from '../../services/api';
import { Typography } from 'antd';
import Title from 'antd/es/typography/Title';

import { Image } from 'antd';

type LoginStatusType = {
    redirect: string | null,
    username: string,
    id: string,
    email: string,
    password: string,
    loading: boolean,
    message: string
  };


export default function LoginForm () {

    const onFinish = (values: any) => {        
        handleLogin(values.email,values.password);      
      };      
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
      };
    const [loginInfo, setLoginInfo] = useState<LoginStatusType>({
        redirect: null,
        username: "",
        id: "",
        email: "",
        password: "",
        loading: false,
        message: ""
    });

    useEffect(()=>{  
        console.log('componentDidMount');
        const currentUser = AuthService.getCurrentToken();
        console.log('currentUser', currentUser);
        if (currentUser) {
          setLoginInfo({...loginInfo,redirect:"/home"});
          console.log('loginInfo', loginInfo);
        };
        return ()=>{
          console.log('componentWillUnmount');
          console.log('reload');
          window.location.reload();
        }    
    },[]); 


    
    const [userAtom, setUserAtom] = useRecoilState<UserType>(UserTypeAtom); 
    const handleLogin = (email: string, webPassword: string) => {       

        setLoginInfo({...loginInfo,message:"",loading:true});
        const loginParm = {email:email, webPassword:webPassword};
        AuthService.login(loginParm).then(
          () => {
            const user = AuthService.getCurrentToken();
            const setJwt = 
            {  
              showModeratorBoard: true,
              showAdminBoard: true,
              currentUser : user 
            };   

            CustomAxios.getAccount()
            .then((response) => {
                console.log("getAccount", response);
              if(response.code == "success"){
                console.log("getAccount data", response.data.address);
                console.log("user.id", user.id);
                const token = localStorage.getItem("tokenOrigin");
                if(token == null){
                  return
                }
                const decodeJwt = jwtDecode<JwtToken>(token);
                console.log("decodeJwt", decodeJwt);

                localStorage.setItem('tokenDecode', JSON.stringify(decodeJwt));
                localStorage.setItem('userId', decodeJwt.id);

                console.log("response.data.id", response.data.id);
                console.log("decodeJwt.name", decodeJwt.name);
                console.log("decodeJwt.organization", decodeJwt.organization);
                console.log("response.data.address", response.data.address);
                console.log("response.data.passwd", response.data.passwd);

                const initCbSignUp ={
                    userId: response.data.id,
                    name: decodeJwt.name,
                    organization: decodeJwt.organization,
                    accountAddr: response.data.address,
                    accountPwd: response.data.passwd,
                  }
                  cbServerSignUP(initCbSignUp);
              }
            })
            .catch((err) => {
                console.log("postJoin error", err);
            });



            setUserAtom(() => ({ ...userAtom, ...setJwt }));            
            console.log('handleLogin succ');
            setLoginInfo({...loginInfo,redirect:"/home"});  //로그인후 이동
          },
          error => {
            console.log("Error:", error); // 전체 에러 객체 출력
          
            // 기본값을 설정하여 안전하게 접근
            const statusCode = error?.response?.status; 
            const resMessage =
              error?.response?.data?.message || // 서버에서 제공한 메시지
              error?.message ||                // 기본 에러 메시지
              "알 수 없는 오류가 발생했습니다."; // 기본 메시지
          
            // 상태 코드 출력
            if (statusCode) {
              console.log(`HTTP 상태 코드: ${statusCode}`);
              switch (statusCode) {
                case 403:
                  console.log("403 Forbidden: 권한이 없습니다.");
                  break;
                case 503:
                  console.log("503 Service Unavailable: 서버가 응답할 수 없습니다.");
                  break;
                default:
                  console.log(`기타 상태 코드: ${statusCode}`);
              }
            } else {
              console.log("response.status를 확인할 수 없습니다. 네트워크 문제일 수 있습니다.");
            }
          
            // 사용자에게 표시할 메시지 설정
            setLoginInfo({ ...loginInfo, message: resMessage, loading: false });
            console.log("handleLogin fail", resMessage);
            window.alert("아이디 또는 비밀번호를 확인해주세요");
          }
        );

        
    }
    
    if (!!loginInfo.redirect?.trim()) {
        console.log("redirect", loginInfo.redirect);
        return <Navigate to={loginInfo.redirect} />
    };
    
  const { loading, message } = loginInfo;
  const handleSignUp = () => {  
    window.location.href = "/register";
  }
  const handleForgotCredentials = () => {
    alert("라임카드 앱에서 계정정보를 확인 가능합니다. \n비밀번호변경(더보기 > 프로필 관리 > 관리자 웹 비밀번호 설정)");
  };

  const cbServerSignUP = (initCbSignUp:CbSignUpType) => {
    CustomAxios.postSignUpUserJwt(initCbSignUp)
    .then((response) => {
        console.log("postSignUpUserJwt", response);     
    })
    .catch((err) => {
        console.log("postSignUpUserJwt error", err);
    });
  };
      
  return (  
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 10 }} 
      size={'large' as SizeType}
      style={{ width: '100%', height: '1000px', padding: '20px', paddingBottom: '300px' }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Image
        src="asset/img/Rhymecard_logo.svg" // Make sure the path is correct
        preview={false} // Set to false if you don't want the image to be clickable
        width={200} // Adjust the width as needed
        alt="RhymeCard Logo"
        style={{ paddingTop: '202px' }}
      />
  
      <Divider />
  
      <div style={{ backgroundColor: '#FFFFFF', borderRadius: '22px', padding: '16px', width: '460px', height: '356px', margin: 'auto' }}>
      <Form.Item
        labelCol={{ span: 2 }}
        wrapperCol={{ offset: 1, span: 10 }}
        name="email"
        rules={[{ required: false, message: 'Please input your email!' }]}
        colon={false}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '8px', width: '50px' }}>ID</label>
          <Input style={{ width: '380px', border: 'none', borderBottom: '1px solid #000', borderRadius: '0' }} placeholder="회원가입시 등록한 이메일을 입력해주세요." />
        </div>
      </Form.Item>
  
      <Form.Item
        labelCol={{ span: 0 }}
        wrapperCol={{ offset: 1, span: 10 }}
        name="password"
        rules={[{ required: false, message: 'Please input your password!' }]}
        colon={false}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '8px', width: '60px' }}>비밀번호</label>
          <Input.Password style={{ width: '380px', border: 'none', borderBottom: '1px solid #000', borderRadius: '0'  }} placeholder="링크와 함께 안내된 비밀번호를 입력해주세요." />
        </div>
      </Form.Item>
  
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ height: "30px",width:"200px", textDecoration: 'underline', cursor: 'pointer' }} onClick={handleForgotCredentials}>
          ID와 비밀번호를 잊으셨나요?
        </div>
        <Form.Item name="remember" valuePropName="checked" style={{ marginLeft: 'auto', width: '150px'}}>
          {/* <Checkbox style={{width: '200px' }}>자동 로그인</Checkbox> */}
        </Form.Item>
      </div>
  
      <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
        <Space style={{ display: 'flex', justifyContent: 'center' }}>
          <Button style={{ width: '380px', height: '56px', backgroundColor: '#123758', borderRadius: '22px' }} type="primary" htmlType="submit">로그인</Button>
        </Space>
      </Form.Item>
      </div>
    </Form>
  );
}